import { numberFixDecimals } from '@local_modules/generic/numbers/number-fix-decimals/index.js'
import { flatRollup, sum } from 'd3'

export function rollupTransactions (transactions) {
  console.group('rollupTransactions()')
  console.log('transactions', transactions)

  const transactionsRollup = flatRollup(transactions,
    function (groupTransactions) {
      const rollupValue = {
        // Group info
        _dateGroup: groupTransactions[0]._dateGroup,
        _entitiesPairId: groupTransactions[0]._entitiesPairId,
        _entitiesPair: groupTransactions[0]._entitiesPair,
        groupTransactions
      }

      // rollupValue.sum = numberFixDecimals(sum(groupTransactions, d => d._converted_amount))
      // rollupValue.totalDebits = numberFixDecimals(sum(groupTransactions, function (value) {
      //   const amount = value._converted_amount
      //   return amount > 0 ? amount : 0
      // }))
      // rollupValue.totalCredits = numberFixDecimals(sum(groupTransactions, function (value) {
      //   const amount = value._converted_amount
      //   return amount < 0 ? amount : 0
      // }))

      // Analysing that debits of 1 entity are the credits of the other
      rollupValue.sideTotals = computeSideTotals(groupTransactions)
      // console.log('rollupValue.sideTotals', rollupValue.sideTotals)

      rollupValue.isBalancingEntity1Debits = rollupValue.sideTotals[rollupValue._entitiesPair[0]]?.[1] === rollupValue.sideTotals[rollupValue._entitiesPair[1]]?.[-1]
      rollupValue.isBalancingEntity1Credits = rollupValue.sideTotals[rollupValue._entitiesPair[0]]?.[-1] === rollupValue.sideTotals[rollupValue._entitiesPair[1]]?.[1]

      rollupValue.isBalancing = rollupValue.isBalancingEntity1Debits && rollupValue.isBalancingEntity1Credits

      return rollupValue
    },
    d => d._dateGroup,
    d => d._entitiesPairId
  )

  console.groupEnd()

  return transactionsRollup
}

function computeSideTotals (groupTransactions) {
  const rollups = flatRollup(groupTransactions,
    groupTransactions => sum(groupTransactions, transaction => Math.abs(transaction._converted_amount)),
    transaction => transaction._entitiesPairIds[0],
    transaction => Math.sign(transaction._converted_amount)
  )
  // console.log('rollups', rollups)

  const rollupTotals = rollups.reduce((acc, rollup) => {
    acc[rollup[0]] = acc[rollup[0]] || {}
    acc[rollup[0]][rollup[1]] = numberFixDecimals(rollup[2])
    return acc
  }, {})
  // console.log('rollupTotals', rollupTotals)

  return rollupTotals
}
